import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import LanguagesListView from "./languages-list.html";

angular.module("languages", [])

    .config(['$stateProvider', function ($stateProvider) {

         $stateProvider
             .state('languages', {
                 url: "/languages",
                 abstract: true,
                 controller: "BreadcrumbCtrl",
                 template: BreadcrumbView
             })
             .state('languages.list', {
                 url: "/list",
                 controller: "LanguagesListCtrl",
                 template: LanguagesListView,
                 data: { pageTitle: 'Traducciones' },
                 requiredPermission: ["RESOURCE_READ"]
             })
     }]);
